export function combineTodoText(dest: string, source: string): string {
  const trimmedDest = dest.trim();
  const trimmedSource = source.trim();
  if (!trimmedSource) return trimmedDest;
  if (!trimmedDest) return trimmedSource;
  if (trimmedDest.toLowerCase() === trimmedSource.toLowerCase()) return trimmedDest;
  const lowerDest = trimmedDest.toLowerCase();
  const lowerSource = trimmedSource.toLowerCase();
  if (lowerDest.includes(lowerSource) || lowerSource.includes(lowerDest)) {
    return trimmedDest.length >= trimmedSource.length ? trimmedDest : trimmedSource;
  }
  return `${trimmedDest} — ${trimmedSource}`;
}
